import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper/modules";
import { useSelector } from "react-redux";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";
export default function VideoInfo({ videoInfo, setVideoInfo }) {
  const data = useSelector((state) => state.main.data?.videosData)?.filter(
    (item) => item.clinc_id == "1"
  );
  const isMobile = /iPhone|Android/i.test(navigator.userAgent);
  return (
    videoInfo && (
      <div className="video-info" data-aos="fade-in">
        <div
          className="content-layout"
          onClick={() => setVideoInfo(false)}
        ></div>
        {isMobile ? (
          <Swiper
            effect={"cards"}
            grabCursor={true}
            modules={[EffectCards]}
            className="container "
          >
            {data?.map((section) => (
              <>
                <SwiperSlide className="section">
                  <div className="image">
                    <video controls>
                      <source
                        src={`https://api.atharalfarasha.com/public/hakim/${section?.video_name}`}
                        type="video/mp4"
                      />
                      <source
                        src={`https://api.atharalfarasha.com/public/hakim/${section?.video_name}`}
                        type="video/webm"
                      />
                      <source
                        src={`https://api.atharalfarasha.com/public/hakim/${section?.video_name}`}
                        type="video/ogg"
                      />
                      Your browser does not support the video tag.
                    </video>
                  </div>

                  {/* <div className="data">
                  <div className="title">
                    <span>{section?.video_info}</span>
                  </div>
                </div> */}
                </SwiperSlide>
              </>
            ))}
          </Swiper>
        ) : (
          <Swiper
            pagination={{
              dynamicBullets: true,
            }}
            slidesPerView={"auto"}
            centeredSlides={true}
            spaceBetween={20}
            modules={[Pagination, Navigation]}
            className="container "
          >
            {data?.map((section) => (
              <>
                <SwiperSlide className="section">
                  <div className="image">
                    <video controls>
                      <source
                        src={`https://api.atharalfarasha.com/public/hakim/${section?.video_name}`}
                        type="video/mp4"
                      />
                      <source
                        src={`https://api.atharalfarasha.com/public/hakim/${section?.video_name}`}
                        type="video/webm"
                      />
                      <source
                        src={`https://api.atharalfarasha.com/public/hakim/${section?.video_name}`}
                        type="video/ogg"
                      />
                      Your browser does not support the video tag.
                    </video>
                  </div>

                  {/* <div className="data">
                  <div className="title">
                    <span>{section?.video_info}</span>
                  </div>
                </div> */}
                </SwiperSlide>
              </>
            ))}
          </Swiper>
        )}
      </div>
    )
  );
}
